module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7Ex7h"))).then(() => parcelRequire('1iHdE'));